import axios, { AxiosResponse } from 'axios';
import { IWarrantyResponse } from '../models/warranty';
import { history } from '../..';
import { toast } from 'react-toastify';
import { IUser, IUserFormValues } from '../models/user';

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
// axios.defaults.baseURL = "http://localhost:3001";

//console.log(axios.defaults.baseURL);

axios.interceptors.request.use(
    config => {
      const token = window.localStorage.getItem('jwt');
      if (token) config.headers.Authorization = `${token}`;
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(undefined, error => {
    if (error.message === 'Network Error' && !error.response) {
      toast.error('Network error - make sure API is running!');
    }
    const { status, data, config } = error.response;
    if (status === 404) {
      history.push('/notfound');
    }
    if (status === 401) {
      window.localStorage.removeItem('jwt');
      window.localStorage.removeItem('jwtuser');
      history.push('/')
      toast.info('Your session has expired, please login again')
    }
    if (
      status === 400 &&
      config.method === 'get' &&
      data.errors.hasOwnProperty('id')
    ) {
      history.push('/notfound');
    }
    if (status === 500) {
      toast.error('Server error - check the terminal for more info!');
    }
    throw error.response;
  });

const responseBody = (response: AxiosResponse) => response.data;


const requests = {
    get: (url: string) =>
      axios
        .get(url)
        .then(responseBody),
    post: (url: string, body: {}) =>
      axios
        .post(url, body)
        .then(responseBody),
    put: (url: string, body: {}) =>
      axios
        .put(url, body)
        .then(responseBody),
    del: (url: string) =>
      axios
        .delete(url)
        .then(responseBody),
    postForm: (url: string, file: Blob) => {
      let formData = new FormData();
      formData.append('File', file);
      return axios
        .post(url, formData, {
          headers: { 'Content-type': 'multipart/form-data' }
        })
        .then(responseBody);
    }
  };

const Warranties = {

    list: (brand : string): Promise<IWarrantyResponse> => requests.post('/warranty/getWarrantyRegistration',{
        brand: brand
  })

}

const User = {

    login: (user: IUserFormValues): Promise<IUser> => requests.post(`/auth`, user),
    
}

export default {
    Warranties,
    User
}